var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboDeleteSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.80087V3.65832C14 3.44505 13.8416 3.27748 13.6401 3.27748H11.2933V1.38085C11.2933 1.16757 11.135 1 10.9334 1H5.06659C4.86503 1 4.70666 1.16757 4.70666 1.38085V3.27748H2.35993C2.15837 3.27748 2 3.44505 2 3.65832V4.80087H3.015L3.71326 14.6496C3.72765 14.8477 3.88602 15 4.07319 15H11.9268C12.114 15 12.2723 14.8477 12.2867 14.6496L12.985 4.80087H14ZM6.14637 2.5234H9.84643V3.27748H6.14637V2.5234ZM10.9262 13.4766H5.07379L4.46191 4.79325H11.5381L10.9262 13.4766Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96833 12.1665H9.68818C9.88254 12.1665 10.0409 11.999 10.0481 11.7933L10.1849 6.39286C10.1849 6.17958 10.0265 6.00439 9.82495 6.00439H9.1051C8.91074 6.00439 8.75237 6.17197 8.74517 6.37763L8.6084 11.7781C8.6084 11.9913 8.76677 12.1665 8.96833 12.1665Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81517 6.39286L5.95194 11.7933C5.95194 11.999 6.11751 12.1665 6.31187 12.1665H7.03172C7.23328 12.1665 7.39885 11.9913 7.39165 11.7781L7.25488 6.37763C7.25488 6.17197 7.08931 6.00439 6.89495 6.00439H6.1751C5.97354 6.00439 5.80797 6.17958 5.81517 6.39286Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboDeleteSmall);
export default __webpack_public_path__ + "static/media/FBODeleteSmall.9a82edb37db75f073991379d6780d2cf.svg";
export { ForwardRef as ReactComponent };